/**
*  The abstractAggregateInput mixin
*  @module framework/mixins/abstractAggregateInput
*/

import abstractInput from './abstractInput';
import { mix, } from '../instance/mix';
import { MutationTypes, } from '../instance/store.constants';

/**
* Extends abstractInput with properties that are useful for input elements that represent multiple
* values.
* @mixes framework/mixins/abstractInput
* @mixin
*/
export default mix({}, abstractInput, {
    methods: {
        /**
         * The error for the input.
         * @param {string} childId The id of the child component.
         * @returns {*} the error object.
         */
        errorText(childId) {
            return this.pluckErrorText(childId);
        },

        /**
         * Gets the error text from the errors array
         * @param {string} controlId The controlId.
         * @returns {string} The error text.
         */
        pluckErrorText(controlId) {
            if (!(this.nodeManifest
                && this.nodeManifest.children
                && this.nodeManifest.children.length > 0)) {
                return null;
            }

            let error = this.nodeManifest.children
                .find((e) => e.errors[0].id === controlId);

            return error ? error.errors[0].localText : '';
        },
        /**
         * Save it to the store
         * @returns {void}
         */
        onDataChanged() {
            if (this.nodeManifest.values[0] !== this.componentValue) {
                this.setValueToManifest(this.componentValue);
            }
        },
        /**
         * Adds the error from the child component to the errors of this component
         * @param {string} childId The id of the child component.
         * @param {object} errorMessageObject The error message object
         *      that the child component is passing.
         * @returns {void}
         */
        onErrorChanged(childId, errorMessageObject) {
            let payload = {
                id: this.nodeManifest.attributes.id,
                childId,
                errorMessageObject,
            };

            this.$store.commit(
                MutationTypes.UpdateError,
                payload);
        },
        /**
         * Get the values(if it exists yet) from manifest
         * @returns {void}
         */
        setComponentValueFromManifest() {
            this.componentValue = this.nodeManifest.values[0];
        },
    },
});



// WEBPACK FOOTER //
// ./source/framework/mixins/abstractAggregateInput.js